import type { WorkspaceStoreState } from './workspace.type'

export const workspaceInitialState: WorkspaceStoreState = {
  workspace: null,
  members: [],
  notifications: [],
  loading: false,
  error: null,
}
